import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DeviceLayer from "../components/DeviceLayer";

const DeviceList = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Devices" />
        <DeviceLayer />
      </MasterLayout>
    </>
  );
};

export default DeviceList;
